import { render, staticRenderFns } from "./HighlevelConceptDetails.vue?vue&type=template&id=21eba0a4&scoped=true&"
import script from "./HighlevelConceptDetails.vue?vue&type=script&lang=ts&"
export * from "./HighlevelConceptDetails.vue?vue&type=script&lang=ts&"
import style0 from "./HighlevelConceptDetails.vue?vue&type=style&index=0&id=21eba0a4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eba0a4",
  null
  
)

export default component.exports